var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadItem'),_c('router-view'),(_vm.viewWidth >= 854)?_c('FootItem'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }